import { motion } from 'motion/react'
import { staggerContainer } from '@/lib/motion/variants'
import InspectorFindingRow from './InspectorFindingRow'
import { pluralize } from './SiteHealthFormat'
import { EYEBROW_CLASS } from './SiteHealthStyles'
import type { InspectorFindingsPanelProps } from './siteHealthInspector.types'

export default function InspectorFindingsPanel({
  findings,
  selectedFindingId,
  attention,
  onSelect,
}: InspectorFindingsPanelProps) {
  if (findings.length === 0) {
    return (
      <section aria-label="Findings on this page">
        <p className="rounded-2xl border border-dashed border-border p-6 text-center text-sm text-muted-foreground">
          This page has no findings to inspect.
        </p>
      </section>
    )
  }

  return (
    <section aria-label="Findings on this page" className="space-y-3">
      <h2 className={EYEBROW_CLASS}>
        {pluralize(findings.length, 'finding')} on this page
      </h2>
      <motion.ul
        initial="hidden"
        animate="shown"
        variants={staggerContainer}
        className="space-y-3"
      >
        {findings.map((finding) => (
          <InspectorFindingRow
            key={finding.id}
            finding={finding}
            expanded={finding.id === selectedFindingId}
            attentionNonce={
              attention?.findingId === finding.id ? attention.nonce : null
            }
            onSelect={onSelect}
          />
        ))}
      </motion.ul>
    </section>
  )
}
